import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Widget from "../../layout/widget/Widget"
import DoughnutChart from "../../charts/generic/DoughnutChart"
import PeopleNPS from "./PeopleNPS"
import ChartComparison from "../../ChartComparison"
import NpsShape from "../../../state/shapes/NpsShape"

const PeopleScaleSection = styled.div`
  padding: 10px;
  margin-bottom: 10px;
`

function CustomNPS({ data, exportEndpoint, appliedFilters, subtitleKey, sampleSize }) {
  const scoreIsPositive = data.currentReviewYearSummary.score >= 0
  const doughnutData = [
    {
      key: "NPSScore",
      // Make value positive so that doughnut shows slice
      value: Math.abs(data.currentReviewYearSummary.score)
    }
  ]

  const hasComparisonData = false//!!(data.previousYears[1] && data.previousYears[1].score)
  const identifier="custom-net-promoter-score"
  const titleKey = "Widgets.EmployeeNetPromoterScore.Title"
  return (
    <Widget
      id={identifier}
      columns={3}
      helpKey="Widgets.NetPromoterScore.Help"
      titleKey={titleKey}
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
      sampleSize={sampleSize}
    >
      <div className="col-lg-9 col-md-12 ">
        <PeopleScaleSection>
          <PeopleNPS data={data.currentReviewYearSummary} widgetIdentifier={identifier} titleKey={titleKey}/>
        </PeopleScaleSection>
      </div>
      <DoughnutChart
        data={doughnutData}
        chartThreshold={100}
        columns={-3}
        prefix={scoreIsPositive ? "+" : "-"}
        hasComparison={hasComparisonData}
        titleKey={titleKey}
        subtitleKey={subtitleKey}
      >
        {hasComparisonData && (
          <ChartComparison
            baseValue={data.currentReviewYearSummary.score}
            comparisonOneValue={data.previousYears[0].score}
            comparisonOneText={data.previousYears[0].clientWorkflowName}
            comparisonTwoValue={data.previousYears[1] ? data.previousYears[1].score : null}
            comparisonTwoText={
              data.previousYears[1] ? data.previousYears[1].clientWorkflowName : null
            }
            usePercentage={false}
            increaseIsGood={false}
          />
        )}
      </DoughnutChart>
    </Widget>
  )
}

CustomNPS.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.shape(NpsShape).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string,
  sampleSize: PropTypes.object
}

export default CustomNPS



// WEBPACK FOOTER //
// ./src/components/widgets/CustomNPS/CustomNPS.jsx